import React from "react";

const EditPatientButton = ({ isEditing, setIsEditing }) => {
  if (isEditing) return null;
  return (
    <button className="smallButton" onClick={() => setIsEditing(true)}>
      Modificar
    </button>
  );
};

export default EditPatientButton;
